/* eslint-disable react-hooks/exhaustive-deps */
import { useLayoutEffect, useState } from 'react';

const defaultOptions = {
  root: undefined,
  rootMargin: '15px',
  threshold: 0,
};

const useViewport = (elementRef, options = defaultOptions) => {
  const [isVisible, setIsVisible] = useState();

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((item) => {
          const nextValue = item.isIntersecting;
          setIsVisible(nextValue);
        }),
      options
    );

    if (elementRef?.current) observer?.observe(elementRef?.current);

    return () => {
      if (elementRef?.current) observer?.disconnect(elementRef?.current);
    };
  }, [elementRef]);

  return isVisible;
};

export default useViewport;
